<template>
  <div>
    <validation-observer tag="form" ref="filterGroups" class="list-filters">
      <b-form @submit.prevent="getOrdersByFilters">
        <b-row>
          <b-col md="">
            <label>Nombre</label>
            <b-form-input v-model="filters.name" placeholder="Nombre del grupo"></b-form-input>
          </b-col>
          <b-col md="">
            <label>Identificador</label>
            <b-form-input v-model="filters.weddingId" placeholder="Identificador de boda"></b-form-input>
          </b-col>
          <b-col md="">
            <label>Tipo de Grupo</label>
            <b-form-group>
              <b-form-select v-model="filters.typegroup">
                <option :value="null">Seleccione tipo de Grupo</option>
                <option v-for="dc in typeGroups" :key="dc.id" :value="dc.id">
                  {{ dc.tipogruponame }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="">
            <label>Fecha llegada</label>
            <flat-pickr
              :class="`form-control flatpickr-color`"
              placeholder="Seleccione una fecha"
              v-model="filters.fini"
            />
          </b-col>
          <b-col md="">
            <label>Fecha Salida</label>
            <flat-pickr
              :class="`form-control flatpickr-color`"
              placeholder="Seleccione una fecha"
              v-model="filters.ffin"
            />
          </b-col>
          <b-col cols="12" class="text-right">
            <div class="float-right">
              <b-button variant="warning" class="mr-1" @click="clearFilter"><feather-icon icon="TrashIcon" size="16" /> Limpiar
              </b-button>
              <b-button variant="success" type="submit">
                <b-icon icon="search" /><span v-if="windowWidth > 767"> Buscar</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <b-row class="mb-1 mt-2">
      <b-col md="2" class="m-0 pt-0">
        <label>Numero de registros</label>
        <v-select
          v-model="porPagina"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="perPageOptions"
          :clearable="false"
          class="per-page-selector p-0"
          @input="changePerPage"
        />
      </b-col>

    </b-row>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";


export default {
  async mounted() {
    await this.getInitialContentCheckout();
  },
  directives: {
    Ripple,
  },
  components: {
		flatPickr,
    vSelect
  },
  props: {
    filters: {
      type: Object,
      required: false,
    },
    perPage: {
      type: Number,
      required: false,
    },
    pageOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      porPagina: this.perPage,
      perPageOptions: this.pageOptions,
    };
  },
  computed: {
    ...mapState("groups", ["typeGroups"]),
    ...mapState('appConfig', ['windowWidth']),
  },
  methods: {
    ...mapActions("groups", ["getInitialContentCheckout"]),
    getOrdersByFilters() {
      // console.log(payload)
      if (this.filters.fini == "") this.filters.fini = null
      if (this.filters.ffin == "") this.filters.ffin = null
      this.$emit("get-Orders-by-Date-Range-filter", this.filters);
    },
    changePerPage() {
      this.$emit("change-per-page", this.porPagina);
    },
    clearFilter() {
      this.$emit("clear-filter");
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

</style>